import React, { useState, useEffect } from "react";
import CurtainClose from "../../../assets/Icons/Curtain All Close.png";
import CurtainOpen from "../../../assets/Icons/Curtain All Open.png";
import CurtainLess from "../../../assets/Icons/Curtain Less Light.png";
import CurtainMore from "../../../assets/Icons/Curtain More Light.png";
import OnioTabs from "../../Components/OnioTabs/index";
import ArrowUp from "../../../assets/Icons/Arrow Up-01.png";
import ArrowBottom from "../../../assets/Icons/Down Arrow White 7.png";
import Box from "@mui/material/Box";
import { ImageButton } from "../../Components/atoms/index";
import Typography from "@mui/material/Typography";
import { ButtonGroup, Button, Container } from "@mui/material";
import "./index.css";
import { TabMenus } from "../../Utils/Types";
import { curtianType } from "./style";

const Curtains = () => {
  // south curtains
  const [countDown, setCountDown] = useState(1);
  const [quickDecOff, setQuickDecOff] = useState(true);
  const [quickIncOff, setQuickIncOff] = useState(true);
  const [curtian, setCurtain] = useState(0);
  const [curtian2, setCurtain2] = useState(0);
  const [curtainsStatus, setCurtainsStatus] = useState<curtianType[]>([
    { isUp: false, isDown: false, isPaused: false, curtain: 1 },
    { isUp: false, isDown: false, isPaused: false, curtain: 2 },
  ]);

  const curtainUp = (id: number) => {
    switch (id) {
      case 1:
        const cur1 = curtainsStatus.map((cur) => {
          if (cur.curtain === id) {
            return { ...cur, isPaused: false, isUp: true, isDown: false };
          }
          return cur;
        });
        setCurtainsStatus(cur1);
        break;
      case 2:
        const cur2 = curtainsStatus.map((cur) => {
          if (cur.curtain === id) {
            return { ...cur, isPaused: false, isUp: true, isDown: false };
          }
          return cur;
        });
        setCurtainsStatus(cur2);
        break;
    }
  };
  const curtainDown = (id: number) => {
    switch (id) {
      case 1:
        const cur1 = curtainsStatus.map((cur) => {
          if (cur.curtain === id) {
            return { ...cur, isPaused: false, isDown: true, isUp: false };
          }
          return cur;
        });
        setCurtainsStatus(cur1);
        break;
      case 2:
        const cur2 = curtainsStatus.map((cur) => {
          if (cur.curtain === id) {
            return { ...cur, isPaused: false, isDown: true, isUp: false };
          }
          return cur;
        });
        setCurtainsStatus(cur2);
        break;
    }
  };

  const stopCurtain = (id: number) => {
    switch (id) {
      case 1:
        const cur1 = curtainsStatus.map((cur) => {
          if (cur.curtain === id) {
            return { ...cur, isDown: false, isPaused: true, isUp: false };
          }
          return cur;
        });
        setCurtainsStatus(cur1);
        break;
      case 2:
        const cur2 = curtainsStatus.map((cur) => {
          if (cur.curtain === id) {
            return { ...cur, isDown: false, isPaused: true, isUp: false };
          }
          return cur;
        });
        setCurtainsStatus(cur2);
        break;
    }
  };
  React.useEffect(() => {
    let interval: any = null;

    if (curtainsStatus[0].isUp && !curtainsStatus[0].isPaused) {
      if (curtian < 100) {
        interval = setInterval(() => {
          setCurtain((time) => time + 4);
        }, 200);
      }
    } else {
      clearInterval(interval);
    }
    return () => {
      clearInterval(interval);
    };
  }, [
    curtainsStatus[0].curtain,
    curtainsStatus[0].isUp,
    curtainsStatus[0].isPaused,
    curtian,
  ]);
  React.useEffect(() => {
    let interval: any = null;

    if (curtainsStatus[0].isDown && !curtainsStatus[0].isPaused) {
      if (curtian > 0) {
        interval = setInterval(() => {
          setCurtain((time) => time - 4);
        }, 200);
      }
    } else {
      clearInterval(interval);
    }
    return () => {
      clearInterval(interval);
    };
  }, [
    curtainsStatus[0].curtain,
    curtainsStatus[0].isDown,
    curtainsStatus[0].isPaused,
    curtian,
  ]);

  React.useEffect(() => {
    let interval: any = null;

    if (curtainsStatus[1].isUp && !curtainsStatus[1].isPaused) {
      if (curtian2 < 100) {
        interval = setInterval(() => {
          setCurtain2((time) => time + 4);
        }, 200);
      }
    } else {
      clearInterval(interval);
    }
    return () => {
      clearInterval(interval);
    };
  }, [
    curtainsStatus[1].curtain,
    curtainsStatus[1].isUp,
    curtainsStatus[1].isPaused,
    curtian2,
  ]);
  React.useEffect(() => {
    let interval: any = null;

    if (curtainsStatus[1].isDown && !curtainsStatus[1].isPaused) {
      if (curtian2 > 0) {
        interval = setInterval(() => {
          setCurtain2((time) => time - 4);
        }, 200);
      }
    } else {
      clearInterval(interval);
    }
    return () => {
      clearInterval(interval);
    };
  }, [
    curtainsStatus[1].curtain,
    curtainsStatus[1].isDown,
    curtainsStatus[1].isPaused,
    curtian2,
  ]);
  const [tab, setTab] = useState<number>(0);
  const handleMenuNavigation = (ele: any, i: number) => {
    setTab(i);
  };
  return (
    <Container>
      <OnioTabs menu={TabMenus} onClick={handleMenuNavigation} />

      <Box sx={{ mt: 4 }}>
        <Typography sx={{ color: "#909090", fontSize: "16px", mb: 1 }}>
          SCENES
        </Typography>
        <div className="boxes-Grid">
          <ImageButton
            variant={"contained"}
            startImg={CurtainClose}
            text={"All Close"}
          />
          <ImageButton
            variant={"contained"}
            startImg={CurtainLess}
            text={"Less Light"}
          />
          <ImageButton
            variant={"contained"}
            startImg={CurtainMore}
            text={"More Light"}
          />
          <ImageButton
            variant={"contained"}
            startImg={CurtainOpen}
            text={"All Open"}
          />
        </div>
      </Box>
      {/* south Curtains */}
      <Box sx={{ mt: 6, mb: 2 }}>
        <Typography sx={{ color: "#909090", fontSize: "16px", mb: 1 }}>
          SOUTH CURTAINS
        </Typography>
        <ButtonGroup size="large" sx={fx} variant="contained">
          <Box>
            <Box>
              <Button className="borderColorX"> {curtian}% OPEN</Button>
            </Box>
            <Box>
              <Button
                className="borderColors"
                onClick={() => curtainUp(1)}
                style={{
                  borderBottomLeftRadius: "10px",
                }}
              >
                <img height={26} src={ArrowUp} alt="" />
              </Button>
              <Button onClick={() => stopCurtain(1)} className="borderColors">
                Stop
              </Button>
              <Button
                style={{
                  borderBottomRightRadius: "10px",
                }}
                onClick={() => curtainDown(1)}
                className="borderColors"
              >
                <img height={26} src={ArrowBottom} alt="" />
              </Button>
            </Box>
          </Box>
        </ButtonGroup>
      </Box>
      {/* East Curstians */}
      <Box sx={{ mt: 6, mb: 2 }}>
        <Typography sx={{ color: "#909090", fontSize: "16px", mb: 1 }}>
          EAST CURTAINS
        </Typography>
        <ButtonGroup size="large" sx={fx} variant="contained">
          <Box>
            <Box>
              <Button className="borderColorX">{curtian2}% OPEN</Button>
            </Box>
            <Box>
              <Button
                onClick={() => curtainUp(2)}
                style={{
                  borderBottomLeftRadius: "10px",
                }}
                className="borderColors"
              >
                <img height={26} src={ArrowUp} alt="" />
              </Button>
              <Button onClick={() => stopCurtain(2)} className="borderColors">
                Stop
              </Button>
              <Button
                onClick={() => curtainDown(2)}
                style={{
                  borderBottomRightRadius: "10px",
                }}
                className="borderColors"
              >
                <img height={26} src={ArrowBottom} alt="" />
              </Button>
            </Box>
          </Box>
        </ButtonGroup>
      </Box>
    </Container>
  );
};

export default Curtains;
const fx = {
  color: "white",
  backgroundColor: "#3E3E3E",
  mr: 2,
  textAlign: "center",
  borderRadius: "10px",
};
